module.exports = "\r\nfunction initLazyLoading()\r\n{\r\n    $(function() {\r\n        $('.lazy').Lazy();\r\n    });\r\n}\r\n\r\ninitLazyLoading();\r\n\r\n"